export default __webpack_public_path__ + "static/media/logo_lego.e437e0d5.svg";